import { render } from "./SpaceCard.vue?vue&type=template&id=36a2bf7c"
import script from "./SpaceCard.vue?vue&type=script&lang=js"
export * from "./SpaceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__